module.exports = __webpack_public_path__ + "img/siyu.bacfd7ea.png";